
/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
module.exports = function() {
	return [ [ "né", "né" ], [ "non", "ma" ], [ "non prima", "che" ], [ "non prima", "di" ], [ "non solo", "ma anche" ],
			[ "o", "o" ], [ "se", "allora" ], [ "se", "o" ], [ "sia", "che" ]  ];
};





// WEBPACK FOOTER //
// ./node_modules/yoastseo/js/researches/italian/twoPartTransitionWords.js